import RouteNavigationInterface from "./interfaces/core/RouteNavigationInterface";
import ErrorPage from "./ui/core/ErrorPage";
import Index from "./ui/main/Index";
import Product from "./ui/product/Product";
import CatalogByPath from "./ui/catalog/CatalogByPath";
import Favorites from "./ui/catalog/Favorites";
import Comparison from "./ui/catalog/Comparison";
import Search from "./ui/catalog/Search";
import Basket from "./ui/checkout/Basket";
import OrderSuccess from "./ui/checkout/OrderSuccess";
import Layout from "./ui/customer/Layout";
import Account from "./ui/customer/Account";
import ProductByCode from "./ui/product/ProductByCode";
import OrderList from "./ui/customer/OrderList";
import Order from "./ui/customer/Order";

export const navigation: RouteNavigationInterface[] = [
    {
        path: '/',
        element:  <Index />,
    },
    {
        path: '/catalog/list/:categoryId/*',
        element:  <CatalogByPath />,
    },
    {
        path: '/favorites',
        element:  <Favorites />,
    },
    {
        path: '/comparison',
        element:  <Comparison />,
    },
    {
        path: '/search',
        element:  <Search />,
    },
    {
        path: '/basket',
        element:  <Basket />,
    },
    {
        path: '/order/success/:orderId',
        element:  <OrderSuccess />,
    },
    {
        path: '/catalog/item/:categoryId/:productId/:slug',
        element:  <Product />,
    },
    {
        path: '/catalog/item-by-code/:code',
        element:  <ProductByCode />,
    },
    {
        path: '/account',
        element: <Layout />,
        children: [
            {
                path: '',
                element: <Account />,
            },
            {
                path: 'profile',
                element: <Account />,
            },
            {
                path: 'order-list',
                element: <OrderList />,
            },
            {
                path: 'order/:id',
                element: <Order />,
            },

        ]
    },
    {
        path: '*',
        element: <ErrorPage />,
    },

]